import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  menuList: any = [{
    "option": "menu.about",
    "routeUrl": "/about"
  },{
    "option": "menu.helpUs",
    "routeUrl": "/help-us"
  },{
    "option": "menu.changeLanguage",
    "routeUrl": "/change-language"
  },{
    "option": "menu.privacyTerms",
    "routeUrl": "/policy-terms"
  },{
    "option": "menu.contactUs",
    "routeUrl": "/contact-us"
  },{
    "option": "menu.becomeAPeerSupport",
    "routeUrl": "/become-a-peer-supporter"
  }]

  /**
   * Creates an instance of menu component.
   * @param commonService 
   */
  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
  }

  /**
   * Navigates to menu
   * @param url 
   */
  navigateToMenu(url: any){
    this.commonService.navigateToPageWithState(url)
  }
}
